import React from "react";
import AntdEmpty from 'antd/lib/empty';

export const Empty = (props) => <AntdEmpty {...props} />

Empty.displayName = 'Empty';

export default Empty;



// WEBPACK FOOTER //
// ./src/components/empty/index.tsx